import { uniq, map } from 'ramda';
import { Routine } from 'redux-saga-routines';
import { IUserInfo } from '../../../../common/models/user/IUserInfo';
import {
  fetchUsersRoutine,
  changeUserRoleRoutine,
  changeUserStatusRoutine,
  changeUserTeamRoutine,
  changeUsersTeamRoutine,
  changeUsersRoleRoutine,
  createUserRoutine,
  setCreateUserErrorRoutine,
  changeUsersStatusRoutine
} from '../../routines';
import { ISettingsUsersCounters } from '../../../../common/models/settings/ISettingsUsersCounters';
import { ISaveUserError } from '../../../../common/models/user/ISaveUserError';
import { updateTeamRoutine } from '../../../../containers/TeamList/routines';

export type UsersAndTeamsState = {
  users: IUserInfo[] | null;
  counters: ISettingsUsersCounters;
  loading: boolean;
  isSaving: boolean;
  saveError: ISaveUserError | null;
};

const initialState: UsersAndTeamsState = {
  users: null,
  counters: {
    active: 0,
    inactive: 0
  },
  loading: true,
  isSaving: false,
  saveError: null
};

export const usersAndTeams = (
  state: UsersAndTeamsState = initialState,
  { type, payload }: Routine<any>
): UsersAndTeamsState => {
  switch (type) {
    case fetchUsersRoutine.TRIGGER:
      return {
        ...state,
        loading: !payload.from
      };
    case fetchUsersRoutine.SUCCESS:
      const items = payload.reset ? payload.items : uniq([...(state.users as IUserInfo[]), ...payload.items]);
      return {
        ...state,
        users: items,
        counters: payload.counters,
        loading: false
      };
    case fetchUsersRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case changeUserRoleRoutine.SUCCESS:
      return {
        ...state,
        users: (state.users as IUserInfo[]).map(user => (user.id === payload.id
          ? { ...user, role: payload.role }
          : user))
      };
    case changeUserTeamRoutine.SUCCESS:
      return {
        ...state,
        users: (state.users as IUserInfo[]).map(user => (user.id === payload.id
          ? { ...user, team: payload.team }
          : user))
      };
    case changeUsersTeamRoutine.SUCCESS:
    case changeUsersRoleRoutine.SUCCESS:
    case changeUserStatusRoutine.SUCCESS:
    case changeUsersStatusRoutine.SUCCESS:
      return {
        ...state,
        users: null
      };
    case createUserRoutine.TRIGGER:
      return {
        ...state,
        isSaving: true
      };
    case createUserRoutine.SUCCESS:
      return {
        ...state,
        isSaving: false,
        saveError: null
      };
    case createUserRoutine.FAILURE:
      return {
        ...state,
        isSaving: false,
        saveError: payload
      };
    case setCreateUserErrorRoutine.TRIGGER:
      return {
        ...state,
        saveError: payload
      };
    case updateTeamRoutine.SUCCESS:
      return {
        ...state,
        users: state.users && map(user => (user.team.id === payload.id
          ? ({ ...user, team: payload })
          : user), state.users as IUserInfo[])
      };
    default:
      return state;
  }
};
